import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";

const MINIMUM_PASSWORD_LENGTH = 8;
const INVALID_TOKEN_MESSAGE = "Il link di reimpostazione non è valido o è scaduto. Richiedi un nuovo link.";

export function ResetPasswordPage() {
  const { token = "" } = useParams();
  const [newPassword, setNewPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [error, setError] = useState("");
  const [completed, setCompleted] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    if (newPassword.length < MINIMUM_PASSWORD_LENGTH) {
      setError(`La password deve contenere almeno ${MINIMUM_PASSWORD_LENGTH} caratteri.`);
      return;
    }
    if (newPassword !== confirmation) {
      setError("Le password non coincidono.");
      return;
    }

    try {
      await api.post("/auth/reset-password", { token, new_password: newPassword });
      setCompleted(true);
    } catch (err) {
      if ([400, 404].includes(err?.response?.status)) {
        setError(INVALID_TOKEN_MESSAGE);
        return;
      }
      setError(err?.userMessage || "Non è stato possibile reimpostare la password. Riprova.");
    }
  };

  return (
    <main
      id="main-content"
      tabIndex={-1}
      className="min-h-screen flex items-center justify-center bg-slate-50 px-5 py-8 outline-none"
      data-testid="reset-password-page"
    >
      <section className="w-full max-w-md rounded-sm bg-white p-6 shadow-sm sm:p-10">
        <p className="section-title text-3xl font-bold text-slate-900">FullBook</p>
        <h1 className="mt-8 text-2xl font-semibold text-slate-950">Reimposta la password</h1>
        {completed ? (
          <div className="mt-5 space-y-5">
            <p className="text-sm leading-6 text-slate-700" role="status" data-testid="reset-password-success">
              Password reimpostata. Ora puoi accedere con la nuova password.
            </p>
            <Link
              to="/login"
              className="inline-flex h-11 w-full items-center justify-center rounded-sm bg-slate-900 px-4 font-medium text-white"
              data-testid="reset-password-login-link"
            >
              Torna ad Accesso
            </Link>
          </div>
        ) : (
          <form className="mt-5 space-y-5" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="reset-password-new" className="text-xs uppercase tracking-[0.2em] text-slate-500">
                Nuova password
              </label>
              <input
                id="reset-password-new"
                name="new_password"
                type="password"
                autoComplete="new-password"
                minLength={MINIMUM_PASSWORD_LENGTH}
                required
                value={newPassword}
                onChange={(event) => setNewPassword(event.target.value)}
                className="mt-2 h-10 w-full rounded-sm border border-slate-200 px-3"
                data-testid="reset-password-new-input"
              />
            </div>
            <div>
              <label htmlFor="reset-password-confirm" className="text-xs uppercase tracking-[0.2em] text-slate-500">
                Conferma password
              </label>
              <input
                id="reset-password-confirm"
                name="password_confirmation"
                type="password"
                autoComplete="new-password"
                minLength={MINIMUM_PASSWORD_LENGTH}
                required
                value={confirmation}
                onChange={(event) => setConfirmation(event.target.value)}
                className="mt-2 h-10 w-full rounded-sm border border-slate-200 px-3"
                data-testid="reset-password-confirm-input"
              />
            </div>
            {error && (
              <div className="text-sm text-red-600" role="alert" data-testid="reset-password-error">
                {error}
              </div>
            )}
            <button
              type="submit"
              className="h-11 w-full rounded-sm bg-slate-900 font-medium text-white"
              data-testid="reset-password-submit"
            >
              Reimposta password
            </button>
          </form>
        )}
      </section>
    </main>
  );
}
